import { SocialFacebook } from './Images.js';
import { SocialInsta } from './Images.js';
import { SocialTiktok } from './Images.js';
import { SocialTwitter } from './Images.js';
import { SocialYoutube } from './Images.js';
import LazyImage from './components/LazyImage';

import './css/App.css';

function Footer() {
  return (
      <footer className="footer-mainbody">
        <div className="footer-area">
            <div className="social-icons-area">
                <a href="https://www.youtube.com/KateBiberdorf" target="_blank" rel="noreferrer noopener" aria-label="Kate the Chemist on YouTube">
                    <LazyImage className="social-icon" src={SocialYoutube} alt="YouTube" />
                </a>
                <a href="https://x.com/K8theChemist" target="_blank" rel="noreferrer noopener" aria-label="Kate the Chemist on X (Twitter)">
                    <LazyImage className="social-icon" src={SocialTwitter} alt="Twitter/X" />
                </a>
                <a href="https://www.instagram.com/katethechemist/?hl=en" target="_blank" rel="noreferrer noopener" aria-label="Kate the Chemist on Instagram">
                    <LazyImage className="social-icon" src={SocialInsta} alt="Instagram" />
                </a>
                <a href="https://www.facebook.com/@katethechemist/" target="_blank" rel="noreferrer noopener" aria-label="Kate the Chemist on Facebook">
                    <LazyImage className="social-icon" src={SocialFacebook} alt="Facebook" />
                </a>
                <a href="https://www.tiktok.com/@katethechemist?lang=en" target="_blank" rel="noreferrer noopener" aria-label="Kate the Chemist on TikTok">
                    <LazyImage className="social-icon" src={SocialTiktok} alt="TikTok" />
                </a>
            </div>
            <br /><br />
            Kate the Chemist (c) 2026
        </div>
      </footer>

  );
}

export default Footer;
